import React from "react";

import { Flex, Skeleton } from "components";

const SkeletonBlock = ({ width, height }: { width: string; height: string }) => (
  <div style={{ width, height }}>
    <Skeleton type="block" width="100%" height="100%" />
  </div>
);

export const SidePanelLoadingSkeleton = () => (
  <Flex vertical gap="1rem" className="historical-practice-data-table-view-side-panel-loading-container">
    <SkeletonBlock width="5rem" height="1.25rem" />
    <Flex vertical>
      <Flex justify="space-between" align="center">
        <SkeletonBlock width="3rem" height="1.25rem" />
        <SkeletonBlock width="6rem" height="1.25rem" />
      </Flex>
      <span className="historical-practice-data-table-view-side-panel-stats-divider" />
      <Flex justify="space-between" align="center">
        <SkeletonBlock width="7rem" height="1.25rem" />
        <SkeletonBlock width="6rem" height="1.25rem" />
      </Flex>
      <span className="historical-practice-data-table-view-side-panel-stats-divider" />
      <Flex justify="space-between" align="center">
        <SkeletonBlock width="7rem" height="1.25rem" />
        <SkeletonBlock width="6rem" height="1.25rem" />
      </Flex>
      <span className="historical-practice-data-table-view-side-panel-stats-divider" />
      <Flex justify="space-between" align="center">
        <SkeletonBlock width="7rem" height="1.25rem" />
        <SkeletonBlock width="6rem" height="1.25rem" />
      </Flex>
    </Flex>
  </Flex>
);

export const MainLoadingSkeleton = () => {
  const TABLE_COLUMNS_HEADER = 6;
  const TABLE_ROWS = 8;

  return (
    <Flex vertical gap="2rem" className="historical-practice-data-table-view-main-loading-container">
      <Flex justify="space-between" align="center">
        <SkeletonBlock width="20rem" height="2rem" />
        <SkeletonBlock width="20rem" height="2rem" />
      </Flex>
      <SkeletonBlock width="100%" height="3rem" />

      <Flex vertical className="historical-practice-data-table-view-main-loading-table-container">
        <Flex justify="space-between" align="center" className="margin-bottom-200">
          {Array.from({ length: TABLE_COLUMNS_HEADER }).map((_, index) => (
            <div key={index}>
              <SkeletonBlock width="5rem" height="1.25rem" />
              {index !== TABLE_COLUMNS_HEADER - 1 && <span className="historical-practice-data-table-view-main-loading-table-header-separator" />}
            </div>
          ))}
        </Flex>
        {Array.from({ length: TABLE_ROWS }).map((_, index) => (
          <div key={index}>
            <SkeletonBlock width="100%" height="2.5rem" />
            {index !== TABLE_ROWS - 1 && <span className="historical-practice-data-table-view-main-loading-table-divider" />}
          </div>
        ))}
      </Flex>
    </Flex>
  );
};
